import { render, staticRenderFns } from "./UploadedVideoInterview.vue?vue&type=template&id=3e196ece&scoped=true&"
import script from "./UploadedVideoInterview.vue?vue&type=script&lang=js&"
export * from "./UploadedVideoInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e196ece",
  null
  
)

export default component.exports